import React from 'react';
import './styles/global.css';

const App: React.FC = () => {
  const pageStyles: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    fontFamily: 'sans-serif',
  };

  const messageBoxStyles: React.CSSProperties = {
    padding: '30px',
    borderRadius: '8px',
    textAlign: 'center',
    color: '#333',
    border: '1px solid #e0e0e0',
    backgroundColor: '#f9f9f9',
  };

  const linkStyles: React.CSSProperties = {
    color: '#007bff',
    textDecoration: 'underline',
  };

  return (
    <div style={pageStyles}>
      <div style={messageBoxStyles}>
        <p style={{ margin: '0 0 10px 0' }}>This site has been abandoned.</p>
        <p style={{ margin: 0 }}>
          If you want anything else, take a handful message at{' '}
          <a href="mailto:harilvfs@chalisehari.com.np" style={linkStyles}>
            harilvfs@chalisehari.com.np
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default App; 
